import React from 'react';

import { getOperationLabels, getShortLabels } from '../../locale/ru/operations';
import { OperationType } from '../../model/operation';
import { Channel } from '../../model/skill';

import Status, { Color } from './Status';

const commonColors: Record<OperationType, Color> = {
    skillCreated: 'green',
    skillWithdrawn: 'yellow',
    skillStopped: 'red',
    skillDeleted: 'red',
    reviewRequested: 'green',
    reviewCancelled: 'red',
    reviewCancelledByUser: 'green',
    reviewApproved: 'green',
    deployRequested: 'green',
    deployCompleted: 'green',
    deployRejected: 'red',
    settingsReviewApproved: 'green',
    deviceTestPrepared: 'green',
    deviceTestStarted: 'green',
    deviceTestCompleted: 'green',
    skillNominated: 'green',
    skillNominationRotationCompleted: 'green',
    skillNominationRotationWithdrawn: 'yellow',
};

interface Props {
    type: OperationType;
    channel: Channel;
    useShortText?: boolean;
}

export const OperationTypeComponent: React.SFC<Props> = ({ channel, type, useShortText }: Props) => {
    let color = commonColors.skillCreated;
    let message = '';
    try {
        color = commonColors[type];
        message = useShortText ? getShortLabels(channel)?.[type] : getOperationLabels(channel)?.[type];
    } catch (_e) {
        console.error('error in operation color');
    }
    return <Status color={color} message={message} />;
};
